import {AddCommentRequest, AddTaskRequest, IRestApiService, Task} from "../types";

export default class ForumApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getAllTasks = (): Promise<Task[]> => {
    const url = `forum/get-all-tasks`;
    return this.restApiService.get<Task[]>(url);
  };

  addTask = ({ title, description, userId, userName }: AddTaskRequest): Promise<Task> => {
    const url = `forum/add-new-task`;
    return this.restApiService.post<Task>(url, {
      title,
      description,
      userId,
      userName,
    });
  };

  addNewComment = ({ taskId, userId, userName, textComment }: AddCommentRequest): Promise<Comment> => {
    const url = `forum/add-new-comment`;
    return this.restApiService.post<Comment>(url, {
      taskId,
      userId,
      userName,
      textComment,
    });
  };

  getTaskById = (taskId: string): Promise<Task> => {
    const url = `forum/get-task-by-id/${taskId}`;
    return this.restApiService.get<Task>(url);
  };
}
